<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Brikker</h1>
    <div class="comp-header__actions">
      <button [admRequiresFeatureRole]="roles['id-tag.create']" (click)="openCreateIdTagModal()" mat-flat-button type="button">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
        <span>Opret brik</span>
      </button>
    </div>
  </div>
  <div>
    @if (state.focusedIdTag() || focusedUser()) {
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til&nbsp;
        @if (state.focusedIdTag()) {
          <strong>Brik Id : {{ state.focusedIdTag()?.printedId }}</strong>
        }
        @if (focusedUser()) {
          <strong>Bruger : {{ focusedUser()?.name }}</strong>
        }
        <button (click)="resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <div class="comp-header__queries">
        <adm-text-search
          placeholder="Navn, regnr. eller Brik ID"
          (search$)="querySearchInput($event)"
          [searchText]="state.form.value.query ?? ''" />

        <adm-org-typeahead
          [initialId]="state.form.value.organizationId ?? undefined"
          [resetTrigger]="state.resetOrgFilterSignal()"
          (itemSelected)="organizationSelected($event)"
          (clearTypeAhead)="clearOrganizations()" />

        @if (state.form.value.organizationId) {
          @let departmentId = state.form.value.departmentId;
          <adm-dep-typeahead
            [organizationId]="state.form.value.organizationId"
            [departmentId]="departmentId !== null && departmentId !== undefined ? departmentId.toString() : null"
            (itemSelected)="departmentSelected($event)"
            [resetTrigger]="state.resetDepartmentFilterSignal()"
            (departmentFetched)="departmentFetched($event)" />
        }
        <adm-admin-enum-select-list
          label="Vælg status"
          (enumChanged)="updateIdTagStatus($event)"
          [enumObject]="state.statusesFiltered"
          [translatePipe]="translateIdTagStatusPipe"
          [initialValue]="state.form.value.idTagStatus" />
        <adm-admin-enum-select-list
          label="Vælg briktype"
          (enumChanged)="updatecustomCombinedIdTagType($event)"
          [enumObject]="customCombinedIdTagTypeEnum"
          [translatePipe]="translateIdTagCombinedTypePipe"
          [initialValue]="state.form.value.customCombinedIdTagType" />

        <div class="comp-header__filter-checkbox">
          <mat-slide-toggle
            [checked]="state.form.value.includeInactive"
            (change)="updateIncludeInactive($event.checked)"
            color="primary"
            matTooltip="Som standard er inaktive, adgang fjernet og spærrede brikker skjult">
            Vis alle brikker
          </mat-slide-toggle>
        </div>
        <button class="comp-header__reset-button" (click)="resetFilter()" mat-stroked-button>Nulstil</button>
      </div>
    }
  </div>
</div>
<div class="comp-main id-tags">
  <adm-id-tags-list (refreshAfterUpdateEvent)="refreshAfterUpdate($event)" [printedId]="state.form.value.printedId ?? undefined" />
</div>
